// extracted by mini-css-extract-plugin
export var contentContainer = "TextBlock-module--contentContainer--9def0";
export var contentWrapper = "TextBlock-module--contentWrapper--9e031";
export var heading = "TextBlock-module--heading--4f6df";
export var subHeadingContainer = "TextBlock-module--subHeadingContainer--b8abb";